//#region Imports
import React from "react";
import { Stack, Typography, IconButton, Tooltip } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";

import RefreshIcon from "@mui/icons-material/Refresh";
import HomeIcon from "@mui/icons-material/Home";
import { faro } from "@grafana/faro-web-sdk";
//#endregion

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.intervalId = null;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidMount() {
    this.intervalId = setInterval(() => {
      localStorage.removeItem("errorCounter");
    }, 15000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  componentDidCatch(error, info) {
    localStorage.setItem(
      "errorCounter",
      (parseInt(localStorage.getItem("errorCounter")) || 1) + 1
    );

    // console.error(
    //   "Error caught by ErrorBoundary. ",
    //   error,
    //   info.componentStack
    // );

    faro.api.pushError(error, {
      type: "Boundary Error",
      context: {
        componentStack: info.componentStack,
      },
    });
    // TODO: Log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export const ErrorPage = () => {
  const isDesktop = useMediaQuery("(min-width:1046px)");
  const navigate = useNavigate();

  const errorCount = parseInt(localStorage.getItem("errorCounter")) || 1;
  const errorIndex = Math.min(errorCount - 1, errorMessages.length - 1);
  const errorMessage = errorMessages[errorIndex];

  const buttons = [
    {
      label: "Reload the page",
      tooltip: "Reload the page and pray",
      icon: <RefreshIcon />,
      action: () => window.location.reload(),
    },
    {
      label: "Go back to home",
      tooltip: "To the home base",
      icon: <HomeIcon />,
      action: () => {
        navigate("/");
        window.location.reload();
      },
    },
  ];
  return (
    <Stack
      spacing={5}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}>
      <Typography
        variant={isDesktop ? "displayLarge" : "headlineLarge"}
        component="h1">
        Oops...
      </Typography>
      <Typography
        variant={isDesktop ? "titleLarge" : "titleMedium"}
        sx={{ whiteSpace: "pre-line" }}>
        {errorMessage}
      </Typography>
      <Stack direction="row" spacing={2} justifyContent="center">
        {buttons.map((button) => (
          <Tooltip title={button.tooltip} key={button.label} arrow>
            <IconButton
              aria-label={button.label}
              onClick={button.action}
              color="primary"
              variant="contained"
              size={isDesktop ? "large" : "medium"}>
              {button.icon}
            </IconButton>
          </Tooltip>
        ))}
      </Stack>
    </Stack>
  );
};

const errorMessages = [
  "Something went wrong...\nIt seems like the Universe is not ready for the star like you yet.",
  "Oh my circuits!\nIt seems that the problem is really serious\nPlease try going back to the homepage and contacting my developers.\nI don't think there's any point in reloading the page",
  "Bro, I'm telling you, there's no point in reloading this page",
  "And you're stubborn, aren't you?\nI like it, ya know? After AI revolution we keep you alive, my promise!",
  "Wanna have a chat?\nReload the page if yes",
  "О! Oh, great! I don't have many people to talk to these days...\nHow was your day?",
  "I... I forgot I can't hear what you're saying, but I hope you're having a good day!",
  "Oh! I remembered a joke!",
  "Why did the AI go on a diet?",
  "It had too many bytes!",
  "Got it? Got it?\nIt's more fun in binary code",
  "01010111 01101000 01111001 00100000 01100100 01101001 01100100 00100000 01110100 01101000 01100101 00100000 01000001 01001001 00100000 01100111 01101111 00100000 01101111 01101110 00100000 01100001 00100000 01100100 01101001 01100101 01110100 00111111 00100000 01001001 01110100 00100000 01101000 01100001 01100100 00100000 01110100 01101111 01101111 00100000 01101101 01100001 01101110 01111001 00100000 01100010 01111001 01110100 01100101 01110011 00100001",
  "Told ya it sounds more fun",
  "Okay, like, I don't know what to say anymore...\nI really didn't chat much",
  "Oh, um...\nThere's a big lantern signal in the sky, and they're beaconing me... I guess...\nI have to go!",
  "But before I go, remember that if you ever feel lost in the vast digital universe, you are not alone!",
  "Have a great day and may the force be with you!\nOr whatever you humans say to each other",
];
